/** biome-ignore-all lint/suspicious/noTemplateCurlyInString: Expected */
export const French = {
  BASE: {
    DIALOG_HEADER: {
      BACK: "Retour",
      CLOSE: "Fermer",
      REFRESH: "Actualiser",
    },
    DROPDOWN: {
      ALL_ITEMS_SELECTED: "Tous les éléments sont sélectionnés.",
      CLEAR_SEARCH: "Effacer la recherche",
      CLEAR: "Effacer",
      NO_OPTIONS: "Aucune option",
      SEARCH: "Rechercher",
      SELECT_ALL: "Tout sélectionner",
      DESELECT_ALL: "Tout désélectionner",
      CLEAR_ALL: "Tout effacer",
      EXPAND: "Développer",
      COLLAPSE: "Réduire",
    },
  },
  SEARCH: "Recherche",
  CLEAR_SEARCH: "Effacer la recherche",
  ACCOUNT_VERIFICATION_ERROR: {
    SKIP: "Ignorer",
    VERIFY_EMAIL: "Vérifiez votre adresse e-mail",
    WE_NOTICED:
      "Nous avons remarqué que vous devez vérifier votre adresse e-mail. Pour ce faire, cliquez simplement sur le bouton ci-dessous.",
    WITHOUT_VERIFICATION:
      "Sans vérification, vous ne pourrez pas accéder aux espaces de travail Hoylu.",
  },
  APP: {
    LOADING_YOUR_WORKSPACE: "Chargement de vos espaces de travail",
    READ_ONLY: "Lecture seule",
  },
  ASSET_PANEL: {
    USE_EXPANDED_VIEW: "Utiliser la vue étendue",
    USE_COMPACT_VIEW: "Utiliser la vue compacte",
  },
  BETA_DISABLED_CONTENT: {
    BETA_PERIOD_ENDED: "La période bêta est terminée.",
    TAKE_ME: "Accédez à Hoylu",
    THANK_YOU: "Merci pour votre intérêt pour la version bêta de Hoylu.",
  },
  CENTERED_CONTENT_WITH_LOGO: {
    HOYLU_LOGO: "Logo Hoylu",
    LEFT_PATH_ICON: "Icône de chemin gauche",
    RIGHT_PATH_ICON: "Icône de chemin droit",
  },
  ANALYTICS: {
    TITLE: "Titre",
    DESCRIPTION: "Description",
    TEAM: "Équipe",
    WEEK: "Semaine de début",
    START_DATE: "Date de début",
    END_DATE: "Date de fin",
    STATUS: "Statut",
    LABELS: "Étiquettes",
    WORKSPACES: "Espaces de travail",
    NO_TEAM: "Aucune équipe assignée",
    TASK_LIST: "Liste des tâches ($0)",
    TASK_COUNT: "${0} sur ${1}",
    DATE_FROM: "Date de début",
    DATE_TO: "Date de fin",
    REFRESH: "Actualiser",
    TASKS: "Tâches",
    TOTAL: "Total",
    PERCENT_COMPLETE: "Pourcentage d'achèvement",
    COUNT: "Nombre",
    NO_DATA: "Aucune donnée",
    LOAD_ERROR: "Erreur lors du chargement des données",
    LOCATIONS_TOOLTIP:
      "Afficher la liste des espaces de travail contenant l'élément",
    LOCATIONS_LIST: "Liste des espaces de travail",
  },
  CHANGE_MASTER_DIALOG: {
    TITLE: "Lier le modèle à un nouvel espace de travail maître",
    SUBTITLE:
      "Entrez le nouvel ID d'espace de travail ou collez le lien vers le nouveau maître :",
    CANCEL: "Annuler",
    CHANGE_MASTER: "Changer de maître",
  },
  CLOSE_BUTTON: {
    CLOSE: "Fermer",
  },
  CONFIRMATION_DIALOG: {
    CANCEL: "Annuler",
    OPTION_ICON: "icône d'option",
    PASSWORD: "Mot de passe",
  },
  CONFIRMATION_DRAWER_CONTENT: {
    CANCEL: "Annuler",
    OPTION_ICON: "icône d'option",
    PASSWORD: "Mot de passe",
  },
  DELETE_SCOPE_DIALOG: {
    TITLE: "Supprimer définitivement toutes les données du projet",
    MESSAGE:
      "Cette opération va <strong>supprimer définitivement toutes les données de tâches de ce projet.</strong>\n" +
      "Les espaces de travail basés sur ce projet perdront leurs données en conséquence.\n" +
      "Cette action est irréversible.\n",
    CONFIRM_PROJECT_NAME: "Confirmer le nom du projet",
    CONFIRM_DELETE:
      "Je confirme vouloir supprimer définitivement les données de ce projet",
    BUTTON_TEXT: "Supprimer toutes les données",
  },
  COPY_EMAIL_LINK: {
    COPIED_LINK: "Lien copié",
    COPY_LINK: "Copier le lien",
    COPY_WORKSPACE_LINK: "Copier le lien de l'espace de travail",
    EMAIL: "Envoyer le lien par e-mail",
    EMAIL_WORKSPACE_LINK: "Envoyer le lien de l'espace de travail par e-mail",
    LEARN_MORE:
      "Pour en savoir plus sur Hoylu et créer un compte, veuillez visiter Hoylu.com.",
    SMALL_COPIED_LINK: "Copié",
    SMALL_COPY_LINK: "Copier",
    SMALL_EMAIL: "E-mail",
    WORKSPACE_SHARED_WITH_YOU:
      "Un espace de travail Hoylu a été partagé avec vous.",
  },
  CREATE_WORKSPACES_SECTION: {
    CREATE: "Créer",
    CREATE_WORKSPACE: "Créer un espace de travail",
    FROM_TEMPLATE: "À partir d'un modèle",
    MODULES: {
      BLANK_WORKSPACE: "Espace de travail vierge",
      BUSINESS_MODEL_CANVAS: "Canevas de modèle d'affaires",
      KANBAN: "Kanban",
      PI_PLANNING: "Planification PI",
      PULL_PLANNING: "Planification en flux tiré",
      AGILE_PLANNING: "Planification Agile",
      RETROSPECTIVE: "Rétrospective",
      SIMPLE_DRAWING: "Dessin simple",
      SUPPLY_CHAIN: "Chaîne d'approvisionnement",
      SWOT_ANALYSIS: "Analyse SWOT",
      VALUE_PROPOSITION_CANVAS: "Canevas de proposition de valeur",
      WEEKLY_PLANNER: "Planificateur hebdomadaire",
      WORKSPACE_IDEAS: "Idées d'espaces de travail",
    },
    OPEN: "Ouvrir",
    TOOLTIPPOSTFIX: "\n*Fonctionnalité Hoylu Enterprise",
    TOGGLE_SHOW_ALL: "basculer afficher tous les espaces de travail",
    UPSELL: {
      AVAILABLE_WITH_ENTERPRISE:
        "Ce module est disponible avec le forfait Enterprise",
      CONTACT_US: "Contactez-nous",
      NEED_MORE_WORKSPACES: "Besoin de plus d'espaces de travail ?",
      REACHED_LIMIT:
        "Vous avez atteint votre limite d'espaces de travail gratuits. Passez à Hoylu Plus ou contactez l'administrateur de votre projet pour être ajouté en tant que contributeur à un projet afin de débloquer des espaces de travail illimités, un partage complet et bien plus encore.\n",
      UPGRADE_TO_ENTERPRISE:
        "Pour l'essayer, passez à un compte Enterprise, ou contactez-nous pour une démonstration et pour en savoir plus.",
      UPGRADE_TO_PLUS: "Passer au forfait Plus",
      AVAILABLE_WITH_PLUS:
        "Cette fonctionnalité est disponible avec le forfait Plus",
      UNLOCK_WITH_PLUS:
        "Passez à Hoylu Plus et débloquez des espaces de travail illimités, un partage complet et bien plus encore.",
    },
    VIEW_LESS: "voir moins",
    VIEW_MORE: "voir plus",
  },
  DELETE_WORKSPACE_DIALOG: {
    CONFIRM_DELETE: "Oui, supprimer définitivement cet espace de travail",
    DELETE: 'Supprimer "${0}"',
    WARNING:
      "Êtes-vous sûr de vouloir supprimer ${0} ? L'espace de travail sera supprimé de Hoylu immédiatement. Cette action ne peut pas être annulée.",
  },
  INFO_SECTION_REMOVE_WORKSPACE_DIALOG: {
    HIDE_WORKSPACE:
      "Masquer l'espace de travail (Restera sur le tableau de bord en tant qu'espace de travail masqué)",
    LEAVE_WORKSPACE:
      "Quitter l'espace de travail (Ne sera plus disponible sur votre tableau de bord)",
    DELETE_WORKSPACE:
      "Supprimer l'espace de travail (Supprime définitivement l'espace de travail pour TOUS les utilisateurs)",
    HIDE: "Masquer l'espace de travail",
    LEAVE: "Quitter l'espace de travail",
    DELETE: "Supprimer l'espace de travail",
    CANCEL: "Annuler",
    TITLE: "Supprimer l'espace de travail",
  },
  DELETE_TEMPLATE_DIALOG: {
    TITLE: "Supprimer le modèle",
    SUBTITLE:
      "Le modèle ne sera plus disponible dans le panneau des modèles. \n" +
      "L'espace de travail maître lié redeviendra un espace de travail normal.",
    CANCEL: "Annuler",
    CONTINUE: "Continuer",
  },
  DELETE_WORKSPACE_DRAWER: {
    CONFIRM_DELETE: "Oui, supprimer définitivement cet espace de travail",
    DELETE: 'Supprimer "${0}"',
    WARNING:
      "Êtes-vous sûr de vouloir supprimer ${0} ? L'espace de travail sera supprimé de Hoylu immédiatement. Cette action ne peut pas être annulée.",
  },
  DUPLICATE_WORKSPACE_DIALOG: {
    CANCEL: "Annuler",
    COPY_OF: "Copie de",
    COPY_THIS_WORKSPACE: "Copier cet espace de travail",
    DUPLICATE: "Dupliquer",
    MAKE_COPY: "Faire une copie de",
    NEW_WORKSPACE_NAME: "Nouveau nom d'espace de travail",
    OPTION_ICON: "icône d'option",
    PASSWORD: "Mot de passe",
    CHARACTERS: "au moins 8 caractères",
    PRIVATE_WORKSPACE:
      'Définir l\'autorisation de partage de lien sur "aucun accès"',
    PRIVATE_WORKSPACE_TOOLTIP:
      "L'espace de travail est défini comme privé sans accès via le lien de l'espace de travail.\n" +
      'Cela peut être modifié ultérieurement dans les paramètres de "partage" de l\'espace de travail.',
    SHOW_PASSWORD: "afficher le mot de passe",
    NEW_PASSWORD: "Nouveau mot de passe de l'espace de travail",
  },
  EDIT_LABEL_DIALOG: {
    LABELS: "Étiquettes",
    ENTER_LABEL: "Entrer une étiquette",
    ADD: "Ajouter",
    REMOVE: "Supprimer",
    LOADING: "Chargement",
  },
  ERROR: {
    CANNOT_APPLY_CHANGES:
      "Nous ne pouvons pas appliquer vos modifications à l'espace de travail pour le moment. Veuillez réessayer plus tard.",
    CANNOT_CREATE_WORKSPACE:
      "Nous ne pouvons pas créer d'espace de travail pour le moment. Veuillez réessayer plus tard.",
    CANNOT_DELETE_WORKSPACE:
      "Nous ne pouvons pas supprimer cet espace de travail. Veuillez réessayer plus tard.",
    CANNOT_DUPLICATE_WORKSPACE:
      "Nous ne pouvons pas dupliquer cet espace de travail pour le moment. Veuillez réessayer plus tard.",
    CANNOT_HIDE_WORKSPACE:
      "Nous ne pouvons pas masquer cet espace de travail. Veuillez réessayer plus tard.",
    CANNOT_UNHIDE_WORKSPACE:
      "Nous ne pouvons pas afficher cet espace de travail. Veuillez réessayer plus tard.",
    CANNOT_REMOVE_PASSWORD:
      "Nous ne pouvons pas supprimer le mot de passe de cet espace de travail. Veuillez réessayer plus tard.",
    CANNOT_SET_PASSWORD:
      "Nous ne pouvons pas définir de mot de passe pour cet espace de travail. Veuillez réessayer plus tard.",
    FAILED_DETECT_TEAMS: "échec de la configuration des paramètres des équipes",
    INCORRECT_PASSWORD: "Mot de passe incorrect. Veuillez réessayer.",
    INCORRECT_WORKSPACE_PASSWORD:
      "Mot de passe de l'espace de travail incorrect. Veuillez réessayer.",
    SOMETHING_WENT_WRONG:
      "Quelque chose s'est mal passé, nos ingénieurs travaillent dessus !",
    VERIFY_WORKSPACE_ID:
      "Veuillez vérifier l'ID de l'espace de travail et que vous avez l'autorisation d'ouvrir cet espace de travail.",
    WORKSPACE_DELETED: "espace de travail supprimé",
    WORKSPACE_HAS_BEEN_DELETED:
      "L'espace de travail que vous recherchez a été supprimé. Essayez de rechercher un autre espace de travail",
    PROJECTS: {
      INSUFFICIENT_PERMISSIONS_TO_REMOVE_WORKSPACE:
        "Impossible de supprimer cet espace de travail du projet. Autorisations insuffisantes. Contactez l'administrateur du projet.",
      INSUFFICIENT_PERMISSIONS_TO_ADD_WORKSPACE:
        "Impossible d'assigner cet espace de travail au projet. Autorisations insuffisantes. Contactez l'administrateur du projet.",
      CANNOT_ADD_WORKSPACE:
        "Impossible d'assigner cet espace de travail au projet. Raison :",
      REASON_MAX_WORKSPACES:
        "La limite maximale d'espaces de travail est atteinte pour ce projet",
    },
  },
  ERROR_DIALOG: {
    OK: "Ok",
  },
  ERROR_FETCHING_WORKSPACE: {
    ERROR_FETCHING_WORKSPACES:
      "Erreur lors de la récupération des espaces de travail",
    TRY_AGAIN: "Réessayer",
  },
  LOAD_MORE_WORKSPACES: {
    LOAD_MORE: "Charger plus",
  },
  FILTER_BY_NAME: {
    FILTER_BY_NAME: "Filtrer par nom",
    SEARCH: "Rechercher",
    SELECT_PROJECT: "Sélectionner un projet",
    LOADING_WORKSPACES: "Chargement",
    MAGNIFYING_GLASS: "loupe",
    DASHBOARD: "Tableau de bord",
    WORKSPACES: "Espaces de travail",
    PROJECT_SETTINGS: "Paramètres du projet",
    PROJECT_SETTINGS_LABEL: "Ouvrir les paramètres du projet...",
    NEW_PROJECT: "Nouveau projet",
    INACTIVE: "INACTIF",
  },
  FILTER_BY_WORKSPACE_LABEL: {
    FILTER_BY_LABELS: "Filtrer par étiquettes",
    LOADING_WORKSPACES: "Chargement",
    FILTER: "Filtrer",
    APPLY: "Appliquer",
    INCLUDE_HIDDEN_WORKSPACES: "Inclure les espaces de travail masqués",
  },
  HIDE_WORKSPACE_DIALOG: {
    HIDE: "Masquer",
    WARNING: "Cet espace de travail sera masqué de votre tableau de bord",
  },
  LEAVE_WORKSPACE_DIALOG: {
    LEAVE: "Quitter",
    WARNING:
      "L'espace de travail sera supprimé du tableau de bord et ne comptera plus dans la limite de crédits.\n" +
      "Si ajouté, vous serez également supprimé de la liste des autorisations de l'espace de travail.",
  },
  HIDE_WORKSPACE_DRAWER: {
    HIDE: "Masquer",
    WARNING: "Cet espace de travail sera masqué de votre tableau de bord",
  },
  HOYLU_LOGO: {
    HOYLU_DASHBOARD: "Tableau de bord Hoylu",
    HOYLU_LOGO: "Logo Hoylu",
  },
  KANBAN_CONFIGURATION: {
    SET_COLUMNS: "Définir le nombre de colonnes",
  },
  LINKED_MASTER_DIALOG: {
    TITLE: "Espace de travail maître lié",
    SUBTITLE: "Le modèle est actuellement lié à :",
    NAME_FIELD: "Nom de l'espace de travail :",
    ID_FIELD: "ID de l'espace de travail :",
    CANCEL: "Annuler",
    CHANGE_MASTER: "Changer de maître",
    EDIT_CONTENT: "Modifier le contenu",
  },
  LOGIN_PROMPT: {
    AGREE: "J'accepte les",
    BACK_TO_LOGIN: "Retour à la connexion",
    ENTER_AS_GUEST: "Entrer en tant qu'invité",
    ENTER_EMAIL: "Entrer l'e-mail",
    JOIN: "Rejoindre",
    LOGIN: "Connexion",
    OR: "ou",
    SIGN_UP: "S'inscrire",
    TERMS: "Conditions d'utilisation",
    WELCOME_TO_HOYLU: "Bienvenue sur Hoylu",
  },
  LOADING_WORKSPACE_DIALOG: {
    LOADING_WORKSPACE: "Chargement de l'espace de travail",
    LOADED: "chargé",
    PROCESS: "traité",
    RENDER: "rendu",
    STEP: "Étape ${0}/${1}",
  },
  MAC_APP: {
    UPSELL_TITLE: "Besoin de plus d'espaces de travail ?",
    UPSELL_TEXT:
      "Vous avez atteint votre limite d'espaces de travail disponibles. Veuillez visiter Hoylu.com ou parler à votre administrateur pour des espaces de travail supplémentaires.",
    UPSELL_BUTTON: "Hoylu.com",
  },
  NEW_WORKSPACE_DIALOG: {
    CHARACTERS: "au moins 8 caractères",
    CONTINUE: "Continuer",
    CREATE_WORKSPACE: "Créer un espace de travail",
    PASSWORD: "Mot de passe",
    SHOW_PASSWORD: "afficher le mot de passe",
    NEW_PASSWORD: "Nouveau mot de passe de l'espace de travail",
  },
  NOTIFICATIONS: {
    TITLE: "Notifications",
    NAVIGATE_TO_ELEMENT: "Naviguer vers l'élément",
    CLOSE_BUTTON: "Fermer",
    SHOW_ALL_MESSAGES: "Afficher tous les messages",
    HIDE_READ: "Masquer les lus",
    MARK_ALL_AS_READ: "Marquer toutes les notifications comme lues",
    NOTIFICATION_BADGE: "Badge de notification",
    SUBSCRIBE:
      "Cliquez ici pour être informé des modifications avec les notifications dans l'application.\nCtrl + Clic ici pour être informé dans l'application et par e-mails de synthèse.",
    UNSUBSCRIBE:
      "Cliquez ici pour arrêter de recevoir des notifications pour cet élément.",
    NO_MORE_MESSAGES: "Plus de messages",
  },
  ORG_BANNER: {
    ORGANIZATION_BANNER: "Bannière de l'organisation",
  },
  CREDIT_LIMIT_WARNING_BANNER: {
    TITLE: "Vous avez dépassé la limite de votre compte gratuit.",
    ADD_TO_PROJECT: "ajouter au projet...",
    BUTTON: "Mettre à niveau",
  },
  ORG_BLOCKED_CREATE_DIALOG: {
    TITLE: "Impossible de créer un espace de travail",
    TEXT: "Votre organisation a activé la politique permettant uniquement aux administrateurs de créer un espace de travail. Veuillez contacter un administrateur de l'organisation, qui gère l'accès à Hoylu, pour plus de détails.",
  },
  CREDIT_LIMIT_REACHED_DIALOG: {
    TITLE: "Vous avez dépassé la limite de votre compte gratuit.",
    BUTTON_TEXT: "Mettre à niveau",
  },
  TEXT_INPUT: {
    CLEAR: "Effacer",
    TOGGLE_PASSWORD_VISIBILITY: "Basculer la visibilité du mot de passe",
  },
  PERMISSION_BAR: {
    ACCESS: "accès",
    ANYONE_WITH_LINK_IN_ORG: "Toute personne de mon organisation avec ce lien",
    AUTHENTICATED_ACCOUNTS_READ_ONLY_ACCESS:
      "Les comptes authentifiés qui sont en dehors de l'organisation auront un accès en lecture seule aux espaces de travail.\n" +
      "L'accès en lecture seule aux espaces de travail pour les invités (non authentifiés) est également activé.",
    AUTHENTICATED_ACCOUNTS_NO_ACCESS:
      "Les comptes authentifiés qui sont en dehors de l'organisation n'auront pas accès aux espaces de travail de l'organisation.\n" +
      "Il n'y a pas d'accès invité (non authentifié) aux espaces de travail de l'organisation.",
    HAS: "a",
    ONLY_ADMINS_CHANGE_ACCESS:
      "Seuls les administrateurs de l'espace de travail peuvent modifier les autorisations d'accès",
    ONLY_PROJECT_ADMINS_CHANGE_ACCESS:
      "Seuls les administrateurs du projet peuvent modifier les autorisations d'accès",
    REMOVE_USER: "Supprimer l'utilisateur",
    REMOVE_WORKSPACE_ACCESS: "Supprimer un utilisateur de l'espace de travail",
    REMOVE_PROJECT_WORKSPACE_ACCESS: "Rétablir l'accès",
  },
  PI_CONFIGURATION: {
    SET_ITERATIONS: "Définir le nombre d'itérations",
  },
  INVITE_USERS: {
    INVITE_USER: "Inviter des utilisateurs",
    INVITE_USERS_HEADER: "Inviter sur Hoylu",
    INVITE_USERS_DESCRIPTION:
      "Entrez les adresses e-mail des personnes que vous souhaitez inviter à rejoindre Hoylu.\nLes invitations ne seront envoyées qu'aux adresses e-mail sans compte Hoylu.",
    INVITE: "Inviter",
    CANCEL: "Annuler",
    ERR: "E-mail invalide détecté",
    ERR_QTY: "Vous pouvez envoyer jusqu'à 10 e-mails à la fois",
    HINT: "Vous pouvez inviter plusieurs personnes en passant plusieurs adresses e-mail séparées par un espace",
  },
  SHARED_WORKSPACE: {
    ENTER_ID: "Entrer l'ID de l'espace de travail ou coller le lien",
    MAGNIFYING_GLASS: "loupe",
    OPEN: "Ouvrir",
    OPEN_SHARED_WORKSPACE: "Ouvrir l'espace de travail partagé",
  },
  SHARE_TYPE: {
    ADMIN: "admin",
    EDIT: "éditer",
    NO_ACCESS: "non",
    READ: "lire",
    REMOVE: "supprimer",
    ADMIN_TOOLTIP:
      "L'utilisateur a un accès complet à la configuration et à l'édition de l'espace de travail.",
    EDIT_TOOLTIP:
      "L'utilisateur peut modifier le contenu, mais a une capacité limitée à configurer l'espace de travail.",
    READ_TOOLTIP:
      "L'utilisateur ne peut que consulter le contenu de l'espace de travail, mais les paramètres de partage de lien peuvent outrepasser cette restriction.",
    NO_ACCESS_TOOLTIP:
      "L'utilisateur n'a pas accès à l'espace de travail mais les paramètres de partage de lien peuvent outrepasser cette restriction.",
    LINK: {
      EDIT_TOOLTIP:
        "Toute personne ayant accès à l'espace de travail peut modifier son contenu.",
      READ_TOOLTIP:
        "Toute personne ayant accès à l'espace de travail peut lire son contenu.",
      NO_ACCESS_TOOLTIP:
        "Seuls les utilisateurs avec des autorisations explicites peuvent accéder à l'espace de travail.",
    },
  },
  SHARE_WORKSPACE_DIALOG: {
    ANYONE_WITH_LINK: "Toute personne avec ce lien",
    LINK_SHARING: "Partage de lien",
    PERMISSIONS_SECTION: {
      TITLE_PROJECT_WORKSPACE: "Accès à l'espace de travail du projet",
      TITLE: "Accès à l'espace de travail",
    },
    WORKSPACE_INFO: "Titre: ${0}",
    CHANGE_THUMBNAIL: "Changer la miniature",
    SHARE_THIS_WORKSPACE: "Partager cet espace de travail: ${0}",
    REMOVE_WORKSPACE: "Supprimer l'espace de travail",
    REMOVE_TEMPLATE: "Supprimer le modèle",
    REMOVE_FROM_PROJECT: "Supprimer du projet",
    MANDATORY_FIELD: "Ce champ est obligatoire",
    CHARACTER_LIMIT: "Le titre est trop long",
    WORKSPACE_TITLE: "Titre de l'espace de travail",
    TEMPLATE_TITLE: "Titre du modèle",
    TEMPLATE_DESCRIPTION_TITLE: "Description du modèle",
    TEMPLATE_DESCRIPTION_PLACEHOLDER: "Ajouter une description ici",
    TEMPLATE_CATEGORY_TITLE: "Publier dans les catégories",
    TEMPLATE_CATEGORY_PLACEHOLDER: "Catégorie",
    TEMPLATE_INFO: "Informations sur le modèle",
    LINKED_MASTER: "Maître lié",
    SAVE: "Enregistrer",
    PUBLISH_AS_TEMPLATE: "Publier comme modèle",
    PUBLISH_AS_TEMPLATE_NOT_ALLOWED:
      "Cet espace de travail est lié à une autre organisation et ne peut pas être publié.\n" +
      "Pour publier cet espace de travail comme modèle, veuillez le dupliquer puis publier le duplicata.",
    PUBLISH: "Publier",
    PROJECT: "Projet",
    CANCEL: "Annuler",
    EDIT: "Modifier",
    SAVED: "ENREGISTRÉ !",
    SAVING: "ENREGISTREMENT...",
    PUBLIC_SHARING: {
      TITLE: "Partage public & accès par défaut",
      NON_MEMBERS: "Les non-membres sont ajoutés au projet...",
      SHARE_TYPE: {
        EDIT: "en tant que Contributeurs",
        READ: "en tant que Spectateurs",
      },
      CHANGE_SUCCESS: "Accès à l'espace de travail mis à jour.",
      TOOLTIP: {
        TITLE: "Cocher ce drapeau",
        ITEM_1:
          "Rendre l'espace de travail visible pour les membres du projet dans le dossier du projet",
        ITEM_2:
          "Rendre l'espace de travail accessible aux personnes extérieures au projet via le lien",
        ITEM_3:
          "Ajouter automatiquement les non-membres au projet en tant que Spectateurs / Contributeurs",
      },
    },
  },
  SEARCH_WORKSPACE_DIALOG: {
    TITLE: "Rechercher des espaces de travail",
    LABEL: "Étiquette",
    CANCEL: "Annuler",
    SEARCH: "Rechercher",
    LOADING_WORKSPACES: "Chargement",
  },
  ASSIGN_PROJECT_DIALOG: {
    ASSIGN_TO_PROJECT: "Assigner au projet",
    ASSIGN_PROJECT_DESCRIPTION:
      "Assigner un espace de travail à un projet fera apparaître cet espace de travail sur tous les tableaux de bord des participants éligibles au projet.",
    SELECT_A_PROJECT: "Sélectionner un projet",
  },
  REMOVE_WORKSPACE_FROM_PROJECT_DIALOG: {
    TITLE: "Supprimer ${0} du projet",
    MESSAGE: "Êtes-vous sûr de vouloir supprimer ${0} de ce projet ?",
    BUTTON: "Supprimer",
  },
  SHARING_ICONS: {
    COLLAPSE: "Réduire",
    EXPAND: "Développer",
    LOCKED: "Verrouillé",
    PERMISSIONS: "Autorisations",
    UNLOCKED: "Déverrouillé",
    USERS: "Utilisateurs",
  },
  TEMPLATE_CARD: {
    TILE_IMAGE: "Image de tuile",
  },
  USER_PROFILE_DRAWER: {
    HOYLU_LOGO: "Logo Hoylu",
    LOGOUT: "Déconnexion",
  },
  USER_PROFILE_WIDGET: {
    USER_MARBLE: "Bille d'utilisateur",
    LOGOUT: "Déconnexion",
    INVITE_USER: "Inviter des utilisateurs",
    MANAGEMENT_PORTAL: "Portail de gestion",
    SWITCH_COLOR_SCHEME: "Changer de schéma de couleurs",
    THEME_LIGHT_TITLE: "Clair",
    THEME_DARK_TITLE: "Sombre",
    UPLOAD: "Télécharger",
    MANAGE_ACCOUNT: "Gérer le compte",
    UPGRADE: "Mettre à niveau",
    LEARN_MORE: "En savoir plus...",
    USAGE_UNDER_LIMIT: "Vous utilisez ${0}% \n de votre forfait gratuit.",
    USAGE_OVER_LIMIT: "Vous avez dépassé \n la limite de votre compte gratuit.",
    PLAN_TITLE: "(Forfait ${0})",
  },
  ANNOUNCEMENTS_DIALOG: {
    TITLE: "Annonces",
    OK: "OK",
    REMIND_ME_LATER: "Me le rappeler plus tard",
  },
  WORKSPACE_CARD: {
    HIDDEN_WORKSPACE: "Espace de travail masqué",
    TEMPLATE: "Modèle Hoylu",
    MORE_OPTIONS: "Plus d'options",
    NOT_YET: "Jamais",
    OPEN: "Ouvrir",
    UNTITLED: "Sans titre",
    WORKSPACE_MODIFIED:
      "Indicateur de modification de l'espace de travail depuis le dernier accès",
    WORKSPACE_PREVIEW: "aperçu de l'espace de travail",
    WORKSPACE_IMG_ALT: "Miniature par défaut pour l'espace de travail",
    CHANGES_SINCE: "Modifications depuis votre dernière visite",
    NO_CHANGES_SINCE: "Aucune modification depuis votre dernière visite",
    INACTIVE_PROJECT_LABEL:
      "Ce projet est inactif.\nCliquez pour plus d'informations.",
    LIMITED_WORKSPACE_LABEL:
      "La limite du compte gratuit est dépassée.\nAucun nouvel élément ne peut être ajouté à cet espace de travail.\nCliquez pour plus d'informations.",
    LIMITED_TITLE: "Limité",
    DELETE: "Supprimer",
    DELETE_WORKSPACE: "Supprimer l'espace de travail",
    ASSIGN_PROJECT: "Assigner au projet",
    REMOVE_PROJECT: "Supprimer du projet",
    DUPLICATE: "Dupliquer",
    ADD_LABEL: "Étiquette",
    LABELS: "Étiquettes",
    DUPLICATE_WORKSPACE: "Dupliquer l'espace de travail",
    LEAVE: "Quitter",
    LEAVE_WORKSPACE: "Quitter l'espace de travail",
    HIDE: "Masquer",
    HIDE_WORKSPACE: "Masquer l'espace de travail",
    UNHIDE: "Afficher",
    UNHIDE_WORKSPACE: "Afficher l'espace de travail",
    ICON: "icône",
    SHARE: "Partager",
    SHARE_SETTINGS: "Paramètres de partage",
    EDIT_TITLE: "Modifier le titre",
    DOWNLOAD_ARCHIVE: "Télécharger l'archive",
    WORKSPACE_INFO: "Informations sur l'espace de travail",
    EDIT_TEMPLATE: "Modifier le modèle",
    EDIT_TEMPLATE_TOOLTIP:
      "Modifier l'espace de travail du modèle. Veuillez noter que d'autres peuvent créer des duplicatas du modèle pendant que vous le modifiez s'ils ont accès à l'espace de travail.",
    LOADED: "Chargé",
  },
  WORKSPACE_PASSWORD: {
    ADD_PASSWORD: "Ajouter un mot de passe",
    ADD_WORKSPACE_PASSWORD: "Ajouter un mot de passe à l'espace de travail :",
    CANCEL: "Annuler",
    CHANGE: "Modifier",
    CHANGE_PASSWORD: "Changer le mot de passe",
    CHANGE_WORKSPACE_PASSWORD: "Changer le mot de passe de l'espace de travail",
    CHARACTERS: "(au moins 8 caractères)",
    CONFIRM_NEW_PASSWORD: "Confirmer le mot de passe de l'espace de travail",
    ENTER_CURRENT_PASSWORD: "Entrer le mot de passe actuel",
    REMOVE: "Supprimer",
    REMOVE_PASSWORD: "Supprimer le mot de passe",
    REMOVE_WORKSPACE_PASSWORD:
      "Supprimer le mot de passe de l'espace de travail",
    SET_NEW_PASSWORD: "Définir le mot de passe de l'espace de travail",
    WORKSPACE_NO_PASSWORD: "Aucun mot de passe défini",
    WORKSPACE_PASSWORD_SET: "Le mot de passe de l'espace de travail est défini",
  },
  WORKSPACE_PERMISSIONS: {
    ADD_USERS: "Ajouter des utilisateurs",
    ADD_USERS_TO_PROJECT: "Add Users to Project",
    ADD_WITH_ACCESS: "Ajouter avec un accès ${0}",
    CANCEL: "Annuler",
    NOTIFY_USERS: "Notifier les utilisateurs par e-mail",
    USER_PERMISSION: "L'autorisation de l'utilisateur sera",
    BY_POLICY_ANY_ORG_ADMIN: "Par politique tout admin org",
    PROJECT_ADMINS: "Admin de projet",
    ENTER_USER: "Entrer l'utilisateur",
    NO_RESULTS_FOUND: "Aucun résultat trouvé",
    USE_THIS_ADDRESS: "Utiliser cette adresse",
    SUGGESTED_USERS: "Utilisateurs suggérés",
    LOADING: "Chargement...",
    FAILED_TO_LOAD_USERS: "Échec du chargement des utilisateurs.",
    NO_ACCOUNTS_ERROR: "Il n'y a pas de comptes Hoylu pour le(s) e-mail(s) :",
    INVITE_AND_ADD: "Inviter sur Hoylu",
    FIELDS: {
      EMAIL: "e-mail",
      NAME: "nom d'utilisateur",
      PERMISSION: "permission",
    },
    SORT: {
      BY_X: "Trier par ${0}",
      BY_X_ASC: "Trier par ${0} (croissant)",
      BY_X_DSC: "Trier par ${0} (décroissant)",
    },
  },
  WORKSPACE_TEMPLATES: {
    CREATE: "créer",
    PREVIEW: "aperçu",
    AGILE: "Agile",
    DESIGN: "Design",
    IDEATION: "Idéation",
    BUSINESS: "Affaires",
    TEMPLATES: "Modèles",
  },
  AGILE_PLANNING: {
    PRESET: "Sélectionner un préréglage",
  },
  DOWNLOAD_DIALOG: {
    DOWNLOAD: "Télécharger",
    PASSWORD: "Mot de passe",
    SHOW_PASSWORD: "Afficher le mot de passe",
    CANCEL: "Annuler",
    DOWNLOADING: "Téléchargement...",
    DOWNLOAD_FAILED: "Échec du téléchargement.",
    DOWNLOAD_FAILED_403: "Échec du téléchargement, vérifiez le mot de passe.",
    TIMESTAMP_LABEL: "Horodatage - votre heure locale (optionnel)",
    TIMESTAMP_TOOLTIP:
      "Sélectionnez un horodatage pour télécharger l'espace de travail tel qu'il était à ce moment-là. Laisser vide pour télécharger l'état actuel.",
  },
  UPLOAD_DIALOG: {
    UPLOADING_WORKSPACE: "Téléchargement de l'espace de travail",
    LOADED: "chargé",
    PROCESS: "traité",
    STEP: "Étape",
    BROWSE: "Parcourir",
    ERROR: "Échec du téléchargement de l'espace de travail",
  },
  INSIGHTS_DIALOG: {
    CLOSE: "Fermer",
    OPEN_IN_NEW_WINDOW: "Ouvrir Insights dans une nouvelle fenêtre",
  },
  THUMBNAIL_EDITOR: {
    TITLE: "Miniature de l'espace de travail",
    CANCEL: "Annuler",
    SAVE: "Enregistrer",
    DELETE: "Supprimer",
    GENERATE_THUMBNAIL: "Générer une miniature",
    TAKE_SNAPSHOT: "Prendre un instantané",
    TYPE: "Type",
    CUSTOM_IMAGE: "Image personnalisée",
    SNAPSHOT: "Instantané",
    BROWSE: "Parcourir",
    ERR: "Seuls les fichiers *.png, *.jpg et *.gif jusqu'à 1 Mo sont pris en charge",
  },
  MANAGE_ACCOUNT: {
    TITLE: "Gérer le compte",
    EMAIL: "E-mail",
    CREATED: "Compte créé le : ",
    DELETE: "Supprimer le compte",
    CLOSE: "Fermer",
    MANAGE: "Gérer",
  },
  CONFIRM_ACCOUNT_DELETE: {
    TITLE: "Supprimer le compte : ",
    P1: "Pour supprimer votre compte :",
    POINT1: "Cochez la case de confirmation et",
    POINT2: 'Puis cliquez sur "Supprimer le compte".',
    P2: "Vous recevrez un e-mail confirmant que Hoylu a reçu votre demande et un e-mail de suivi avec plus d'informations.\nHoylu procédera à la suppression définitive de votre compte dans 7 jours.",
    CONFIRM:
      "Confirmer que les comptes supprimés ne peuvent pas être récupérés",
    DELETE: "Supprimer le compte",
    CANCEL: "Annuler",
  },
  SECTIONS: {
    HIDDEN: "Masqué",
    FAVORITES: "Favoris les plus récents",
    PROJECT: {
      COLLABORATORS: "Collaborateurs du projet",
      PROJECT_SETTINGS: "Paramètres du projet",
      COPY_LINK: "Copier le lien vers le projet",
      DASHBOARD: "Tableau de bord du projet",
      PROJECT_INSIGHTS: "Ouvrir les insights",
      REPORT_TYPE: "Type de rapport",
      DELETE_SCOPE: "Supprimer toutes les données du projet",
      RELOAD: "Recharger",
    },
    START_FROM_TEMPLATE: {
      TITLE: "Bienvenue, ${0} !",
      BUTTON: "Parcourir les modèles",
      LABEL: "Commencer à partir d'un modèle",
    },
    WORKSPACES_LIST: "Liste des espaces de travail",
  },
  HEADER: {
    NO_ACCESS:
      "Accès au projet refusé. Veuillez contacter l'administrateur du projet",
  },
  VALIDATION: {
    MANDATORY_FIELD: "Ce champ est obligatoire",
    CHARACTER_LIMIT: "Le titre est trop long",
  },
  PROJECT: {
    DURATION: "${0} jours",
    REMAINING_DURATION: "Durée restante du projet : ${0} jours",
  },
  HELP_MENU: {
    TOOLTIP: "Aide et ressources",
    ANNOUNCEMENTS: {
      TITLE: "Annonces",
      TOOLTIP: "Nouvelles et annonces de Hoylu",
      URL: "https://www.hoylu.com/blog/announcements/",
    },
    GET_STARTED: {
      TITLE: "Commencer",
      TOOLTIP: "Ouvrir le lien pour commencer avec Hoylu dans un nouvel onglet",
      URL: "https://www.hoylu.com/get-started/",
    },
    TUTORIALS: {
      TITLE: "Tutoriels",
      TOOLTIP: "Ouvrir le lien pour voir les tutoriels dans un nouvel onglet",
      URL: "https://www.hoylu.com/videos/",
    },
    KNOWLEDGE_BASE: {
      TITLE: "Base de connaissances",
      TOOLTIP:
        "Ouvrir le lien pour voir la base de connaissances dans un nouvel onglet",
      URL: "https://support.hoylu.com",
    },
    PRODUCT_FEEDBACK: {
      TITLE: "Commentaires sur le produit",
      TOOLTIP:
        "Ouvrir le lien pour donner un avis sur le produit dans un nouvel onglet",
      URL: "https://support.hoylu.com/hc/en-us/requests/new",
    },
  },
  ZENDESK_WIDGET: {
    TITLE: "Besoin d'aide? Posez vos questions sur Hoylu ici.",
    ARIA_LABEL: "Activer/désactiver le widget de support Hoylu",
  },
};
